import Brand from "../../../shared/components/Brand";
import SignUpForm from "../components/SignUpForm";
import { Link } from "react-router-dom";

export default function SignUp() {
  return (
    <div className="px-6 flex flex-col items-center justify-between h-full">
      <Brand size="xl" />
      <SignUpForm />
      <p className="text-center text-label-dark text-sm pb-10">
        Already have an account?{" "}
        <Link to="/sign-in" className="text-gray-200 underline">
          Sign In Here
        </Link>
      </p>
    </div>
  );
}
